import PropTypes from 'prop-types';
import React from 'react';

function formatTime(duration) {
  if (!duration) {
    return null;
  }
  return duration.substring(0, duration.lastIndexOf(':'));
}
function formatDistance(d, units = 'imperial') {
  if (units === 'imperial') {
    return `${parseFloat(d * 0.621371).toFixed(1)} mi.`;
  }
  return `${parseFloat(d).toFixed(1)} km`;
}
class DistanceTo extends React.Component {
  render() {
    const { distance, duration } = this.props;
    if (!distance) {
      return null;
    }
    return (
      <p>
        <i className="fa fa-road" />
        From venue: {formatDistance(distance)}{' '}
        {duration && (
          <span>
            <i className="fa fa-clock-o" /> {formatTime(duration)}
          </span>
        )}
      </p>
    );
  }
}

DistanceTo.propTypes = {
  distance: PropTypes.number,
  duration: PropTypes.string,
};

export default DistanceTo;



// WEBPACK FOOTER //
// src/components/HotelDetail/DistanceTo.js